import { Result } from '@otto-ec/eprivacy-measures'
import { LOAD_CB_LAZY_TOGGLE } from './core'
import { measureInit } from './singletons/measure-init.singleton'
import { __loadOneTrustSDK } from '@otto-ec/eprivacy-cmp'
import { hasConsentBeenGiven } from '@otto-ec/eprivacy-onetrust-sdk'

export const bootstrapLazy = async () => {
  if (!hasConsentBeenGiven()) {
    await importBootstrapAndSignalCmpOnetrustReady()
    return
  }

  await measureInit.startLoad()
  __loadOneTrustSDK.on(
    async () => {
      await importBootstrapAndSignalCmpOnetrustReady()
    },
    { once: true }
  )
  /*                                                                  */
  setTimeout(
    () =>
      measureInit.endLoad(Result.CBHidden, {
        toggle: LOAD_CB_LAZY_TOGGLE,
      }),
    0
  )
}

async function importBootstrapAndSignalCmpOnetrustReady() {
  await (await import('./bootstrap')).bootstrap()
}
